import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom"; 
import config from '../../config';

function ProjectsList() {
    const [projects, setProjects] = useState([]);
    const [categoryMap, setCategoryMap] = useState({}); // id -> name
    const [menus, setmenus] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const fetchProjects = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-projects`, { withCredentials: true });
            
            if(response.data){
                setProjects(response.data);
            }

        } catch (err) {
            setError('Failed to fetch projects');
        } finally {
            setLoading(false);
        }
    };

    const fetchCategories = async () => {
        try {
            const res = await axios.get(`${config.BASE_URL}/api/admin/categories/list`, { withCredentials: true });
            const list = res?.data?.data || [];
            const map = {};
            list.forEach(c => { if (c?._id) map[c._id] = c?.name; });
            setCategoryMap(map);
        } catch (e) {
            // silent fail; will fallback to raw values
        }
    };

    useEffect(() => {
        fetchProjects();
        fetchCategories();
    }, []);

    return (
        <>
            <div className="dashboard">
                <div className="container">
                    <h1 className="dash_title">Projects</h1>
                    <div className="main-section">
                        <div className="projects">
                            <div className="projects-inner">
                                <header className="projects-header">
                                    <div className="title">
                                        Total 
                                        <div className="count"> {projects.length } Projects</div>
                                    </div>
                                    <div className="project_search">
                                        <form action="">
                                            <input type="text" name="search" placeholder="Search projects" />
                                            <button type="submit" className="btn">Search</button>
                                        </form>
                                    </div>
                                    <div className="add_project">
                                    <Link to="/admin/add-project">Add Project</Link>
                                    </div>
                                </header>
                                <table className="projects-table">
                                    <thead>
                                        <tr>
                                            <th>Project Title</th>
                                            <th>Categories</th>
                                            <th>Ano</th>
                                            <th>Cliente</th>
                                            <th className="text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="4">Loading...</td>
                                            </tr>
                                        ) : error ? (
                                            <tr>
                                                <td colSpan="4">{error}</td>
                                            </tr>
                                        ) : (
                                            projects.map((project, index) => ( 
                                                <tr key={project._id}>
                                                    <td><p>{project.title}</p></td>
                                                    <td><p>{Array.isArray(project.category) && project.category.length > 0 ? project.category.map(c => categoryMap[c] || c).join(', ') : '-'}</p></td>
                                                    <td><p>{project.ano}</p></td>
                                                    <td><p>{project.cliente}</p></td>
                                                    <td>
                                                        <Link to={`/admin/project/${project._id}`} className="view_detail">View Details</Link>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProjectsList;
